import { NgModule } from '@angular/core';
import { SharedModule } from '../../../../../shared';
import { CampanhaROIChartModule } from '../../charts/roi';

import { CampanhaDashboardComponent } from './campanha-dashboard.component';

@NgModule({
    imports: [
        SharedModule,
        CampanhaROIChartModule
    ],
    declarations: [
        CampanhaDashboardComponent
    ],
    exports: [
        CampanhaDashboardComponent
    ]
})
export class CampanhaDashboardModule { }
